import { render, staticRenderFns } from "./TrustPilotRating.vue?vue&type=template&id=3e66cd72&"
import script from "./TrustPilotRating.vue?vue&type=script&lang=ts&"
export * from "./TrustPilotRating.vue?vue&type=script&lang=ts&"
import style0 from "./TrustPilotRating.vue?vue&type=style&index=0&id=3e66cd72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports